import { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./BookAndPageNumberUIHelpers";

const BookAndPageNumberUIContext = createContext();

export function useBookAndPageNumberUIContext() {
  return useContext(BookAndPageNumberUIContext);
}

export const BookAndPageNumberUIConsumer = BookAndPageNumberUIContext.Consumer;

export function BookAndPageNumberUIProvider({ bookAndPageNumberParameters, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    term: bookAndPageNumberParameters.term,
    date: bookAndPageNumberParameters.date,
    dateEnd: bookAndPageNumberParameters.dateEnd,
    sectionId: bookAndPageNumberParameters.sectionId,
    studentId: bookAndPageNumberParameters.studentId
  };

  return (
    <BookAndPageNumberUIContext.Provider value={value}>
      {children}
    </BookAndPageNumberUIContext.Provider>
  );
}